import type { RegisteredComponent } from "@builder.io/sdk-react";

export const hoverParallaxImageBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "HoverParallaxImage",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "foregroundImage",
      friendlyName: "Foreground Image",
      helperText: "Image in the front",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "image",
      friendlyName: "Main Image",
      helperText: "Main image behind the foreground",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "backgroundImage",
      friendlyName: "Background Image",
      helperText: "Image behind the main image",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "animationIcon",
      friendlyName: "Animation Icon at the bottom",
      helperText: "Icon at the bottom for animation",
      type: "uiBlocks",
      defaultValue: [],
    },
  ],
};
